export default "__VITE_ASSET__2d5a9c63__"